import { createAction } from '@reduxjs/toolkit';

import { CHANGE_QUERY_PARAMS } from 'common/constants/actionTypes';
import { FetchQueryPagePayload } from './reducers';

export const updateQueryParams = createAction<FetchQueryPagePayload>(CHANGE_QUERY_PARAMS);
